import styled from "@emotion/styled"
import { motion } from "framer-motion"

import { fullGrid } from "css/grid"
import getMediaQuery from "css/breakpoints"

import { isInnerCN, fullWidthInnerStyle } from "components/figcaption/FigCaption"

export const Root = styled.section`
  ${fullGrid}
  align-items: center;
  background: rgb(var(--pure-white));
  position: relative;
`

export const Edito = styled(motion.div)`
  grid-column: col 1 / span 6;
  grid-row-start: ${props => (props.order === "text-image" ? "1" : "2")};
  margin-block: 50px;

  ${getMediaQuery("m")} {
    margin-block: 0;
    grid-row-start: 1;
    grid-column: ${props => (props.order === "text-image" ? "col 1 / span 6" : "col 7 / span 6")};

    [dir="rtl"] & {
      grid-column: ${props => (props.order === "text-image" ? "col 7 / span 6" : "col 1 / span 6")};
    }
  }

  ${getMediaQuery("l")} {
    grid-column: ${props => (props.order === "text-image" ? "col 1 / span 5" : "col 8 / span 5")};

    [dir="rtl"] & {
      grid-column: ${props => (props.order === "text-image" ? "col 8 / span 5" : "col 1 / span 5")};
    }
  }

  [dir="rtl"] & {
    text-align: right;
  }

  .paragraph {
    margin-block-start: 20px;
  }

  .paragraph + button {
    margin-block-start: 30px;
  }
`
export const Media = styled.div`
  grid-column: doc-start / doc-end;
  grid-row-start: ${props => (props.order === "text-image" ? "2" : "1")};

  [dir="trl"] & {
    grid-row-start: ${props => (props.order === "text-image" ? "1" : "2")};
  }

  ${getMediaQuery("m")} {
    grid-row-start: 1;
    grid-column: ${props => (props.order === "text-image" ? "col 7 / doc-end" : "doc-start / span 7")};

    [dir="rtl"] & {
      grid-column: ${props => (props.order === "text-image" ? "doc-start / span 7" : "col 7 / doc-end")};
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
  }
`

export const FCaption = styled.div`
  display: grid;

  figcaption {
    padding-inline: 20px;
    width: 75%;
  }
`
